<template>
  <card-edit @edit="$emit('edit')">
    <v-card-title class="py-2 font-weight-black">
      {{ $t('delivery.product.products') }}
    </v-card-title>

    <v-card-text class="px-1 my-0 px-md-12">
      <order-items :items="$store.getters.orderSystem.order.items"></order-items>
    </v-card-text>
    <v-divider></v-divider>
  </card-edit>

</template>

<script>
import OrderItems from "@/modules/delivery/components/OrderItems/OrderItems.vue";
import CardEdit from "@/modules/delivery/components/CardEdit/CardEdit.vue";

export default {
  name: "OrderReviewItems",
  components: {OrderItems, CardEdit},
  data() {
    return {
      hover: false,
    }
  }
}
</script>

<style scoped>

</style>
